import React, { memo } from 'react';

import giftBox from '../../assets/images/alyce-gift-box.svg';
import alyceGiftHandBox2 from '../../assets/images/alyce-gift-hand-box2.svg';
import alyceGiftHandBox from '../../assets/images/alyce-gift-hand-box.svg';
import ExpanderWrapper from '../../../../components/Layout/ExpandedWrapper';

import MessageItem from './MessageItem';
import MessageHeader from './MessageHeader';

const RecipientCodeMessage = () => (
  <ExpanderWrapper>
    <MessageHeader />
    <MessageItem title="Accept your personalized gift." message="Why wouldn’t you?" icon={giftBox} />
    <MessageItem title="Exchange the gift." message="The power of choice is yours." icon={alyceGiftHandBox2} />
    <MessageItem title="Donate the value." message="Help a charity close to your heart." icon={alyceGiftHandBox} />
  </ExpanderWrapper>
);

RecipientCodeMessage.propTypes = {};

export default memo(RecipientCodeMessage);
